import { render, staticRenderFns } from "./ScoreStatus.vue?vue&type=template&id=b650e868&scoped=true"
import script from "./ScoreStatus.vue?vue&type=script&lang=js"
export * from "./ScoreStatus.vue?vue&type=script&lang=js"
import style0 from "./ScoreStatus.vue?vue&type=style&index=0&id=b650e868&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b650e868",
  null
  
)

export default component.exports